<header></header>
<div class="post-login-2">
    <!-- <div class="post-login-2-col-1 h-100">
        <app-left-panel-prelogin activeTab="2" *ngIf="this.auth?.detailuser == undefined"></app-left-panel-prelogin>
        <left-panel activeTab="2" *ngIf="this.auth?.detailuser != undefined"></left-panel>
    </div> -->
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="2"></left-panel>
    </div>
    <div class="post-login-2-col-2 has-banner">
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15 h-100 pt-70-pb-70-pr-40">
        <div class="onboarding-canvas h-100">
            <!-- sinnad -->
            <grid-row class="mt-30">
                <grid-col col="9">
                    <div class="font-400 font-size-20px line-h-25">
                        {{ "Please confirm your new card PIN" | translate }}
                    </div>
                    <div class="font-400 font-size-14px color-base-400 mt-10 line-h-20">
                        {{ "You will be able to authenticate any future card activity." | translate }}
                    </div>
                </grid-col>
            </grid-row>
            
            <grid-row class="mt-50 justify-content-center text-align-center">
                <grid-col col="12">
                    <!-- <form [formGroup]="otpform"> -->
                        <!-- formControlName="changeotp" -->
                    <div class="form-group">
                        <ng-otp-input (onInputChange)="onOtpChange($event)" 
                            (keydown)="onKeyDown($event)" allowNumbersOnly='true'
                            [config]="{length:4,allowNumbersOnly:true,isPasswordInput:true}"></ng-otp-input>
                            <span *ngIf="showError" class="color-red">
                                {{ "Invalid PIN Match" | translate }}
                              </span>
                        <!-- <ng-container item-content *ngFor="let validation of errorkey.validation_messages.otp1">
                                            <span class="color-red"
                                            *ngIf="otpform.controls.changeotp.hasError(validation.type) &&(otpform.controls.changeotp.touched)">
                                              {{ getMessage(validation.key,'otp1') }}
                                            </span>
                                          </ng-container> -->
                    </div>
                    <!-- </form> -->
                </grid-col>
            </grid-row>
            
            
            <grid-row class="justify-content-between align-item-center mt-50">
                <grid-col col="auto">
                    <div class="mt-15">
                        <button class="btn-back" (click)="back2sinnad()">
                            <i class="icon-back"></i>
                        </button>
                    </div>
                </grid-col>
                <grid-col col="9">
                    <button class="btn-dft" [disabled]="isValid()" (click)="sendEmailMobileOtp()">
                        {{ "Next" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>

<!-- <div class="pre-login">
    <div class="pre-login-col-1 h-100">
        <left-panel-onboarding></left-panel-onboarding>
    </div>
    <div class="pre-login-col-2">
    </div>
    <div class="pre-login-col-3">
        <div class="onboarding-canvas">
          

        </div>
    </div>
</div> -->

<modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="false" modalDoneButtonText="Verify"
    [modalDoneButtonDisabled]="isValidOtpemail()" (doneButton)="VerifyEmailOTP()">
    <grid-row class="justify-content-center">
        <grid-col col="6"  mobile="12">
            <div class="text-align-center">
                <ng-icon iconClass="icon-otp-pin br-8 bg-nuetral-primary" width="80" height="80"></ng-icon>
                <div class="mt-30">
                    <div class="color-base-700 font-size-20px font-400 line-h-25">
                        {{ "Enter6digit" | translate }}
                    </div>
                    <div class="color-primary font-size-16px font-400 line-h-25">
                        {{"+973"+this.mobilNomasked}}  
                    </div>
                    <div class="color-primary font-size-16px font-400 line-h-25">
                         {{ "Or" | translate }}
                    </div>
                    <div class="color-primary font-size-16px font-400 line-h-25">
                        {{this.maskedEmail}}
                    </div>
                </div>
            </div>
        </grid-col>
    </grid-row>
    <div class="mt-50 form-group">
        <ng-otp-input #otpInput (onInputChange)="onOtpChangeverify($event)" allowNumbersOnly="true"
            [config]="{length: 6, allowNumbersOnly: true,isPasswordInput:true}">
        </ng-otp-input>
    </div>
    <grid-row class="justify-content-center mt-50">
        <grid-col col="auto" *ngIf="!OptTimerbtnShow">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15 link" (click)="resendEmailOTP()">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                </div>
            </div>
        </grid-col>
        <grid-col col="auto" *ngIf="OptTimerbtnShow">
            <div class="border box-shadow br-40 pt-10 pb-10 pl-15 pr-15">
                <div class="font-600 font-size-12px color-primary letter-spacing-1">
                    {{ "Resend" | translate }}
                    <span *ngIf="true"
                        class="font-600 font-size-12px color-primary letter-spacing-1">{{timerexpire}}</span>
                </div>
            </div>
        </grid-col>
    </grid-row>
</modal>